export const isOph = (rank?: string) => {
  if (!rank) {
    return false
  }

  return rank.includes('OPH')
}
